module.exports = __webpack_public_path__ + "img/intro_no.f5607629.svg";